function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlower19(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg4409",
    viewBox: "0 0 79.374996 79.375002",
    height: 300,
    width: 300,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,-217.62499)",
    id: "layer1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1795",
    style: {
      fill: "#850257",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 47.241691,225.46914 c -1.635832,-2.25142 -4.288367,-3.71651 -7.284508,-3.71651 -2.99579,0 -5.648677,1.46509 -7.284861,3.71651 l 1.974496,3.42054 5.310365,9.19762 5.31001,-9.19762 1.974498,-3.42054"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1797",
    style: {
      fill: "#7bc02a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.957183,238.0873 h -7.267224 c 2.615142,8.19608 7.267224,19.49062 7.267224,19.49062 0,0 4.651726,-11.29454 7.266868,-19.49062 h -7.266868"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1799",
    style: {
      fill: "#850257",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 22.404054,229.72259 c -2.748527,-0.43569 -5.660707,0.40428 -7.779032,2.52271 -2.118466,2.11843 -2.958394,5.03061 -2.523349,7.77945 l 3.814833,1.02165 10.25839,2.7492 -2.748774,-10.25843 -1.022068,-3.81458"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1801",
    style: {
      fill: "#7bc02a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 26.174896,243.7956 -5.138279,5.13856 c 7.645082,3.94687 18.920566,8.64376 18.920566,8.64376 0,0 -4.696884,-11.27584 -8.643761,-18.92053 l -5.138526,5.13821"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1803",
    style: {
      fill: "#850257",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 7.8485137,250.29306 c -2.25171,1.63547 -3.71669,4.28872 -3.71669,7.28451 0,2.99578 1.46498,5.64903 3.71669,7.2845 l 3.4198633,-1.97414 9.198151,-5.31036 -9.197869,-5.31037 -3.4201453,-1.97414"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1805",
    style: {
      fill: "#7bc02a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 20.466528,257.57757 v 7.26722 c 8.196157,-2.6155 19.490655,-7.26687 19.490655,-7.26687 0,0 -11.29478,-4.65244 -19.490655,-7.26722 v 7.26687"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1807",
    style: {
      fill: "#850257",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 12.101673,275.13073 c -0.435716,2.74884 0.40446,5.66067 2.522926,7.77875 2.118466,2.11843 5.030541,2.95875 7.779455,2.52342 l 1.021786,-3.81459 2.749056,-10.25878 -10.258813,2.74885 -3.81441,1.02235"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1809",
    style: {
      fill: "#7bc02a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 26.174896,271.35953 5.138526,5.13892 c 3.946877,-7.6454 8.643761,-18.92053 8.643761,-18.92053 0,0 -11.27633,4.69618 -18.920566,8.64341 l 5.138279,5.1382"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1811",
    style: {
      fill: "#850257",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 32.672322,289.68599 c 1.635477,2.25213 4.288367,3.71686 7.284509,3.71686 2.995787,0 5.648677,-1.46508 7.284508,-3.71686 l -1.974498,-3.41948 -5.31001,-9.19833 -5.310717,9.19798 -1.973792,3.41983"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1813",
    style: {
      fill: "#7bc02a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.956831,277.06818 7.26722,2.7e-4 c -2.615493,-8.19679 -7.266868,-19.49062 -7.266868,-19.49062 0,0 -4.652786,11.29418 -7.267575,19.49027 h 7.267223"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1815",
    style: {
      fill: "#850257",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 57.509993,285.4329 c 2.748843,0.43568 5.659962,-0.40428 7.778752,-2.52307 2.11843,-2.11808 2.95875,-5.03026 2.52342,-7.7791 l -3.81459,-1.022 -10.258776,-2.7492 2.748844,10.25914 1.02235,3.81423"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1817",
    style: {
      fill: "#7bc02a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 53.738799,271.35953 5.138912,-5.1382 c -7.645397,-3.94723 -18.920528,-8.64341 -18.920528,-8.64341 0,0 4.696176,11.27583 8.643056,18.92053 l 5.13856,-5.13892"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1819",
    style: {
      fill: "#850257",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 72.065255,264.86207 c 2.25213,-1.63547 3.71651,-4.28766 3.71651,-7.28415 0,-2.99579 -1.46473,-5.64903 -3.71651,-7.28486 l -3.41983,1.9745 -9.197976,5.31036 9.197976,5.31071 3.41983,1.97344"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1821",
    style: {
      fill: "#7bc02a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 59.447449,257.57792 v -7.26758 c -8.196791,2.6155 -19.490266,7.26758 -19.490266,7.26758 0,0 11.293826,4.65208 19.490266,7.26722 v -7.26722"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1823",
    style: {
      fill: "#850257",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 67.812165,240.02475 c 0.43568,-2.74884 -0.40429,-5.66031 -2.52307,-7.7791 -2.11843,-2.11843 -5.030259,-2.95875 -7.779102,-2.52306 l -1.021996,3.81458 -2.749198,10.25843 10.259126,-2.74885 3.81424,-1.022"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1825",
    style: {
      fill: "#7bc02a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 53.738799,243.7956 -5.13856,-5.13821 c -3.94688,7.6454 -8.643056,18.92053 -8.643056,18.92053 0,0 11.275483,-4.69689 18.920528,-8.64341 l -5.138912,-5.13891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1827",
    style: {
      fill: "#850257",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 34.399874,225.12589 c -2.373135,-1.4545 -5.383988,-1.79246 -8.152482,-0.64629 -2.768212,1.14653 -4.65776,3.51508 -5.30793,6.22159 l 3.132984,2.40418 8.425603,6.46536 1.386417,-10.52971 0.515408,-3.91513"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1829",
    style: {
      fill: "#7bc02a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 32.498049,239.57073 -6.713678,2.78095 c 5.552687,6.57189 14.172812,15.22624 14.172812,15.22624 0,0 -0.02434,-12.21493 -0.745067,-20.78814 l -6.714067,2.78095"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1831",
    style: {
      fill: "#850257",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 13.080243,238.56037 c -2.706193,0.64912 -5.0750613,2.5393 -6.2215883,5.30755 -1.146246,2.76789 -0.807791,5.77955 0.646324,8.15269 l 3.9154103,-0.51541 10.529605,-1.38642 -6.465076,-8.42574 -2.404675,-3.13267"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1833",
    style: {
      fill: "#7bc02a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 21.949994,250.11878 -2.781018,6.71407 c 8.573594,0.72073 20.788207,0.74507 20.788207,0.74507 0,0 -8.654699,-8.62048 -15.226312,-14.17285 l -2.780877,6.71371"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1835",
    style: {
      fill: "#850257",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 7.5049787,263.13523 c -1.454538,2.37243 -1.79257,5.38374 -0.646324,8.15199 1.146527,2.76789 3.5149723,4.65842 6.2215883,5.30789 l 2.403828,-3.13302 6.465923,-8.42574 -10.529605,-1.38607 -3.9154103,-0.51505"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1837",
    style: {
      fill: "#7bc02a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 21.949994,265.03635 2.780877,6.71442 c 6.571613,-5.55343 15.226312,-14.17285 15.226312,-14.17285 0,0 -12.21546,0.0236 -20.788207,0.74471 l 2.781018,6.71372"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1839",
    style: {
      fill: "#850257",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 20.939462,284.45429 c 0.649041,2.70651 2.539295,5.07471 5.307506,6.22159 2.768212,1.14618 5.779771,0.80821 8.152554,-0.64629 l -0.515408,-3.91512 -1.386065,-10.52972 -8.425885,6.46536 -3.132702,2.40418"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1841",
    style: {
      fill: "#7bc02a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 32.498049,275.58475 6.714067,2.7813 c 0.720373,-8.57391 0.745067,-20.78813 0.745067,-20.78813 0,0 -8.620832,8.65434 -14.172812,15.22589 l 6.713678,2.78094"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1843",
    style: {
      fill: "#850257",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 45.514139,290.02959 c 2.372783,1.45486 5.383742,1.79282 8.152342,0.64629 2.767893,-1.14653 4.658077,-3.51508 5.307893,-6.22159 l -3.133018,-2.40347 -8.425747,-6.46607 -1.386416,10.52972 -0.515054,3.91512"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1845",
    style: {
      fill: "#7bc02a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 47.415609,275.58475 6.714422,-2.78059 c -5.55343,-6.57225 -14.172848,-15.22624 -14.172848,-15.22624 0,0 0.02328,12.21493 0.74436,20.78778 l 6.714066,-2.78095"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1847",
    style: {
      fill: "#850257",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 66.833205,276.59511 c 2.70686,-0.64911 5.07506,-2.53894 6.22159,-5.30754 1.14617,-2.76825 0.80821,-5.77991 -0.64629,-8.15234 l -3.91478,0.5154 -10.530059,1.38572 6.465709,8.42645 2.40383,3.13231"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1849",
    style: {
      fill: "#7bc02a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 57.963666,265.03635 2.781299,-6.71407 c -8.573557,-0.72037 -20.787782,-0.74436 -20.787782,-0.74436 0,0 8.653639,8.62012 15.225535,14.17285 l 2.780948,-6.71442"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1851",
    style: {
      fill: "#850257",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 72.408855,252.02061 c 1.4545,-2.37314 1.79282,-5.38409 0.64629,-8.15269 -1.14653,-2.76755 -3.51543,-4.65808 -6.22194,-5.30755 l -2.40383,3.13267 -6.465357,8.42574 10.529707,1.38678 3.91513,0.51505"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1853",
    style: {
      fill: "#7bc02a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 57.964018,250.11878 -2.7813,-6.71371 c -6.571896,5.55308 -15.225535,14.17285 -15.225535,14.17285 0,0 12.214576,-0.024 20.787432,-0.74472 l -2.780597,-6.71442"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1855",
    style: {
      fill: "#850257",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 58.974374,230.70119 c -0.649465,-2.70686 -2.538941,-5.07471 -5.307541,-6.22123 -2.768249,-1.14653 -5.779911,-0.80857 -8.152694,0.64593 l 0.515408,3.91513 1.386062,10.53006 8.426099,-6.46571 3.132666,-2.40418"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1857",
    style: {
      fill: "#7bc02a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 47.415609,239.57108 -6.714418,-2.78094 c -0.720373,8.57355 -0.744008,20.78778 -0.744008,20.78778 0,0 8.619773,-8.65399 14.172848,-15.22589 l -6.714422,-2.78095"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1859",
    style: {
      fill: "#7bc02a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 44.355968,238.18855 c -0.987777,-1.35961 -2.589387,-2.24402 -4.398785,-2.24402 -1.809399,0 -3.411009,0.88441 -4.39914,2.24402 l 1.19239,2.06551 3.20675,5.55413 3.20675,-5.55413 1.192035,-2.06551"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1861",
    style: {
      fill: "#7bc02a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.957183,245.80819 h -4.388557 c 1.579033,4.94948 4.388557,11.76973 4.388557,11.76973 0,0 2.809168,-6.82025 4.388201,-11.76973 h -4.388201"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1863",
    style: {
      fill: "#7bc02a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 29.357198,240.75712 c -1.659572,-0.26317 -3.417816,0.24412 -4.697306,1.5233 -1.279243,1.27917 -1.786361,3.03776 -1.523577,4.69758 l 2.303392,0.61737 6.194742,1.65981 -1.65989,-6.19477 -0.617361,-2.30329"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1865",
    style: {
      fill: "#7bc02a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 31.634449,249.25518 -3.103103,3.10304 c 4.616872,2.38336 11.425837,5.2197 11.425837,5.2197 0,0 -2.836334,-6.80932 -5.2197,-11.42577 l -3.103034,3.10303"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1867",
    style: {
      fill: "#7bc02a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 20.567811,253.17878 c -1.359429,0.98778 -2.244125,2.58939 -2.244125,4.39879 0,1.80939 0.884696,3.41136 2.244125,4.39913 l 2.065267,-1.19238 5.554168,-3.20675 -5.553745,-3.2064 -2.06569,-1.19239"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1869",
    style: {
      fill: "#7bc02a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 28.187246,257.57757 v 4.38855 c 4.949685,-1.57939 11.769937,-4.3882 11.769937,-4.3882 0,0 -6.820252,-2.80952 -11.769937,-4.38856 v 4.38821"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1871",
    style: {
      fill: "#7bc02a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 23.136315,268.17748 c -0.263172,1.65982 0.243946,3.41771 1.523577,4.69724 1.279101,1.27952 3.037487,1.78681 4.697306,1.52329 l 0.617079,-2.30329 1.660172,-6.19442 -6.194742,1.65982 -2.303392,0.61736"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1873",
    style: {
      fill: "#7bc02a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 31.634449,265.9003 3.103034,3.10303 c 2.383366,-4.6168 5.2197,-11.42541 5.2197,-11.42541 0,0 -6.809669,2.83598 -11.425837,5.21935 l 3.103103,3.10303"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1875",
    style: {
      fill: "#7bc02a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 35.558043,276.96694 c 0.987779,1.3596 2.58939,2.24402 4.398788,2.24402 1.809395,0 3.41136,-0.88477 4.398785,-2.24402 l -1.192035,-2.06552 -3.20675,-5.55413 -3.20675,5.55413 -1.192038,2.06552"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1877",
    style: {
      fill: "#7bc02a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.956831,269.34729 4.388553,2.6e-4 c -1.579385,-4.94982 -4.388201,-11.76972 -4.388201,-11.76972 0,0 -2.809875,6.8199 -4.388909,11.76937 h 4.388557"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1879",
    style: {
      fill: "#7bc02a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 50.556743,274.39801 c 1.659821,0.26352 3.417713,-0.24342 4.697238,-1.52329 1.279525,-1.27953 1.786466,-3.03742 1.523293,-4.69724 l -2.303285,-0.61701 -6.194425,-1.66017 1.659819,6.19478 0.61736,2.30293"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1881",
    style: {
      fill: "#7bc02a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 48.279564,265.9003 3.102679,-3.10303 c -4.61645,-2.38337 -11.42506,-5.21935 -11.42506,-5.21935 0,0 2.835981,6.80931 5.219348,11.42541 l 3.103033,-3.10303"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1883",
    style: {
      fill: "#7bc02a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 59.346201,261.9767 c 1.359604,-0.98777 2.244014,-2.58903 2.244014,-4.39878 0,-1.8094 -0.88476,-3.41136 -2.244014,-4.39914 l -2.065515,1.19239 -5.55413,3.20675 5.55413,3.20675 2.065515,1.19203"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1885",
    style: {
      fill: "#7bc02a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 51.726556,257.57792 v -4.38891 c -4.949825,1.57939 -11.769373,4.38891 -11.769373,4.38891 0,0 6.8199,2.80952 11.769373,4.38855 v -4.38855"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1887",
    style: {
      fill: "#7bc02a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 56.777274,246.978 c 0.263173,-1.65982 -0.243416,-3.41806 -1.523293,-4.69758 -1.279525,-1.27882 -3.037417,-1.78647 -4.697238,-1.5233 l -0.61736,2.30329 -1.659819,6.19477 6.194777,-1.65981 2.302933,-0.61737"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1889",
    style: {
      fill: "#7bc02a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 48.279564,249.25518 -3.103033,-3.10303 c -2.383367,4.61681 -5.219348,11.42577 -5.219348,11.42577 0,0 6.80861,-2.83634 11.42506,-5.2197 l -3.102679,-3.10304"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1891",
    style: {
      fill: "#577c2b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 36.601208,237.98111 c -1.432984,-0.87806 -3.251552,-1.08232 -4.922661,-0.39017 -1.671991,0.6925 -2.813297,2.12266 -3.205621,3.75708 l 1.891629,1.45168 5.088361,3.9042 0.83679,-6.35847 0.311502,-2.36432"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1893",
    style: {
      fill: "#6f1910",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 35.452916,246.7039 -4.054475,1.67922 c 3.353152,3.9684 8.558742,9.1948 8.558742,9.1948 0,0 -0.01482,-7.37623 -0.450144,-12.55325 l -4.054123,1.67923"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1895",
    style: {
      fill: "#577c2b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 23.726971,246.09359 c -1.634102,0.39229 -3.064228,1.53388 -3.756942,3.20534 -0.692221,1.67111 -0.487857,3.49038 0.390384,4.92301 l 2.364281,-0.3115 6.35829,-0.83714 -3.903556,-5.08812 -1.452457,-1.89159"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1897",
    style: {
      fill: "#6f1910",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 29.082984,253.0733 -1.679151,4.05447 c 5.177473,0.43533 12.55335,0.45015 12.55335,0.45015 0,0 -5.226402,-5.20559 -9.1948,-8.55874 l -1.679399,4.05412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1899",
    style: {
      fill: "#577c2b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 20.360413,260.93354 c -0.878241,1.43263 -1.082605,3.25155 -0.390384,4.92266 0.692714,1.67146 2.12284,2.81305 3.756942,3.20569 l 1.451751,-1.89194 3.904262,-5.08847 -6.35829,-0.83679 -2.364281,-0.31115"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1901",
    style: {
      fill: "#6f1910",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 29.082984,262.08148 1.679399,4.05483 c 3.968398,-3.35315 9.1948,-8.55839 9.1948,-8.55839 0,0 -7.376232,0.0145 -12.55335,0.44944 l 1.679151,4.05412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1903",
    style: {
      fill: "#577c2b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 28.472926,273.80781 c 0.392324,1.63372 1.53363,3.06388 3.205267,3.75673 1.671108,0.69215 3.490031,0.48789 4.923015,-0.39017 l -0.311502,-2.36467 -0.837142,-6.35811 -5.088009,3.90384 -1.891629,1.45238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1905",
    style: {
      fill: "#6f1910",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 35.452564,268.45159 4.054475,1.67922 c 0.434975,-5.17737 0.450144,-12.55289 0.450144,-12.55289 0,0 -5.205942,5.22605 -8.558742,9.19409 l 4.054123,1.67958"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1907",
    style: {
      fill: "#577c2b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 43.312451,277.17437 c 1.432983,0.87842 3.251555,1.08267 4.923015,0.39017 1.67146,-0.69285 2.81305,-2.12301 3.20534,-3.75673 l -1.891597,-1.45203 -5.088466,-3.90419 -0.837142,6.35811 -0.31115,2.36467"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1909",
    style: {
      fill: "#6f1910",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 44.460743,268.45159 4.054475,-1.67958 c -3.3528,-3.96839 -8.558035,-9.19409 -8.558035,-9.19409 0,0 0.0141,7.37588 0.449439,12.55289 l 4.054121,-1.67922"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1911",
    style: {
      fill: "#577c2b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 56.186724,269.06189 c 1.634067,-0.39264 3.064227,-1.53352 3.756729,-3.20533 0.692152,-1.67147 0.488246,-3.49039 -0.39017,-4.92302 l -2.364317,0.31115 -6.358467,0.83714 3.904192,5.08847 1.452033,1.89159"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1913",
    style: {
      fill: "#6f1910",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 50.830499,262.08183 1.679575,-4.05447 c -5.177366,-0.43498 -12.552891,-0.44944 -12.552891,-0.44944 0,0 5.225343,5.20559 9.193741,8.55839 l 1.679575,-4.05448"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1915",
    style: {
      fill: "#577c2b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 59.553634,254.22194 c 0.878065,-1.43263 1.082671,-3.2512 0.390174,-4.92266 -0.692857,-1.67146 -2.123017,-2.8134 -3.757084,-3.20569 l -1.452033,1.89159 -3.90384,5.08847 6.358115,0.83714 2.364668,0.31115"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1917",
    style: {
      fill: "#6f1910",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 50.830851,253.07365 -1.679927,-4.05447 c -3.968398,3.3535 -9.193741,8.55874 -9.193741,8.55874 0,0 7.375876,-0.0145 12.552891,-0.44979 l -1.679223,-4.05448"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1919",
    style: {
      fill: "#577c2b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 51.440806,241.34802 c -0.39229,-1.63442 -1.533173,-3.06458 -3.204988,-3.75673 -1.67146,-0.6925 -3.490384,-0.48824 -4.923367,0.38982 l 0.311505,2.36432 0.837141,6.35882 5.088112,-3.90455 1.891597,-1.45168"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1921",
    style: {
      fill: "#6f1910",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 44.461097,246.70425 -4.054829,-1.67922 c -0.434621,5.17736 -0.449085,12.55289 -0.449085,12.55289 0,0 5.205235,-5.2264 8.558035,-9.19445 l -4.054121,-1.67922"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1923",
    style: {
      fill: "#564118",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 44.079743,257.57757 c 0,2.27682 -1.845734,4.12256 -4.12256,4.12256 -2.276827,0 -4.122915,-1.84574 -4.122915,-4.12256 0,-2.27683 1.846088,-4.12292 4.122915,-4.12292 2.276826,0 4.12256,1.84609 4.12256,4.12292"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlower19);
export default __webpack_public_path__ + "static/media/flower-19.41ff95ab71416b16050a1101ae09d500.svg";
export { ForwardRef as ReactComponent };